var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mt-2", attrs: { "data-runs": "" } },
    [
      _vm._t("title", function () {
        return [
          _c("div", { staticClass: "card-header" }, [
            _c("h1", { staticClass: "text-center" }, [
              _vm._v(_vm._s(_vm.T.latestSubmissionsTitle)),
            ]),
          ]),
        ]
      }),
      _c(
        "div",
        {
          staticClass: "px-2 px-sm-4 border-0",
          class: {
            "single-problem-runs": !_vm.showAllRuns,
            "all-runs": _vm.showAllRuns,
          },
        },
        [
          _c("div", [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.T.wordsSubmissions)),
            ]),
            _vm.showFilters
              ? _c(
                  "div",
                  [
                    _vm.showFilters
                      ? _c("b-pagination", {
                          attrs: {
                            size: "sm",
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.itemsPerPage,
                            limit: 1,
                            "hide-goto-end-buttons": "",
                          },
                          on: { "page-click": _vm.onPageClick },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "page",
                                fn: function ({ page, active }) {
                                  return [
                                    active
                                      ? _c(
                                          "b",
                                          { attrs: { "data-page": "" } },
                                          [
                                            _vm._v(
                                              _vm._s(page) +
                                                " - " +
                                                _vm._s(_vm.totalPages)
                                            ),
                                          ]
                                        )
                                      : _c("i", [_vm._v(_vm._s(page))]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2472186140
                          ),
                          model: {
                            value: _vm.currentPage,
                            callback: function ($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage",
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "filters row" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-3 col-sm pr-0 font-weight-bold" },
                          [
                            _vm._v(" " + _vm._s(_vm.T.wordsExecution) + " "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterExecution,
                                    expression: "filterExecution",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { "data-select-execution": "" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.filterExecution = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(_vm._s(_vm.T.wordsAll)),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "EXECUTION_JUDGE_ERROR" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsJudgeError) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "EXECUTION_VALIDATOR_ERROR",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsValidatorError) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "EXECUTION_COMPILATION_ERROR",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.T.runDetailsCompilationError
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "EXECUTION_RUNTIME_FUNCTION_ERROR",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.T.runDetailsRuntimeFunctionError
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  {
                                    attrs: { value: "EXECUTION_RUNTIME_ERROR" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsRuntimeError) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "EXECUTION_INTERRUPTED" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsInterrupted) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "EXECUTION_FINISHED" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsFinished) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "label",
                          { staticClass: "col-3 col-sm pr-0 font-weight-bold" },
                          [
                            _vm._v(" " + _vm._s(_vm.T.wordsOutput) + " "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterOutput,
                                    expression: "filterOutput",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { "data-select-output": "" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.filterOutput = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(_vm._s(_vm.T.wordsAll)),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "OUTPUT_EXCEEDED" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsExceeded) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "OUTPUT_INCORRECT" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsIncorrect) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "OUTPUT_INTERRUPTED" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsInterrupted) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "OUTPUT_CORRECT" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.T.runDetailsCorrect) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "label",
                          { staticClass: "col-5 col-sm pr-0 font-weight-bold" },
                          [
                            _vm._v(_vm._s(_vm.T.wordsLanguage) + ": "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterLanguage,
                                    expression: "filterLanguage",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { "data-select-language": "" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.filterLanguage = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(_vm._s(_vm.T.wordsAll)),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "cpp20-gcc" } },
                                  [_vm._v("C++20 (g++ 10.3)")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "cpp20-clang" } },
                                  [_vm._v("C++20 (clang++ 10.0)")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "cpp17-gcc" } },
                                  [_vm._v("C++17 (g++ 10.3)")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "cpp17-clang" } },
                                  [_vm._v("C++17 (clang++ 10.0)")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "cpp11-gcc" } },
                                  [_vm._v("C++11 (g++ 10.3)")]
                                ),
                                _c(
                                  "option",
                                  { attrs: { value: "cpp11-clang" } },
                                  [_vm._v("C++11 (clang++ 10.0)")]
                                ),
                                _c("option", { attrs: { value: "c11-gcc" } }, [
                                  _vm._v("C (gcc 10.3)"),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "c11-clang" } },
                                  [_vm._v("C (clang 10.0)")]
                                ),
                                _c("option", { attrs: { value: "cs" } }, [
                                  _vm._v("C# (10, dotnet 6.0)"),
                                ]),
                                _c("option", { attrs: { value: "hs" } }, [
                                  _vm._v("Haskell (ghc 8.8)"),
                                ]),
                                _c("option", { attrs: { value: "java" } }, [
                                  _vm._v("Java (openjdk 16.0)"),
                                ]),
                                _c("option", { attrs: { value: "kt" } }, [
                                  _vm._v("Kotlin (1.6.10)"),
                                ]),
                                _c("option", { attrs: { value: "pas" } }, [
                                  _vm._v("Pascal (fpc 3.0)"),
                                ]),
                                _c("option", { attrs: { value: "py3" } }, [
                                  _vm._v("Python (3.9)"),
                                ]),
                                _c("option", { attrs: { value: "py2" } }, [
                                  _vm._v("Python (2.7)"),
                                ]),
                                _c("option", { attrs: { value: "rb" } }, [
                                  _vm._v("Ruby (2.7)"),
                                ]),
                                _c("option", { attrs: { value: "lua" } }, [
                                  _vm._v("Lua (5.3)"),
                                ]),
                                _c("option", { attrs: { value: "go" } }, [
                                  _vm._v("Go (1.18.beta2)"),
                                ]),
                                _c("option", { attrs: { value: "rs" } }, [
                                  _vm._v("Rust (1.56.1)"),
                                ]),
                                _c("option", { attrs: { value: "js" } }, [
                                  _vm._v("JavaScript (Node.js 16)"),
                                ]),
                                _c("option", { attrs: { value: "kp" } }, [
                                  _vm._v("Karel (Pascal)"),
                                ]),
                                _c("option", { attrs: { value: "kj" } }, [
                                  _vm._v("Karel (Java)"),
                                ]),
                                _c("option", { attrs: { value: "rk" } }, [
                                  _vm._v("ReKarel"),
                                ]),
                                _c("option", { attrs: { value: "cat" } }, [
                                  _vm._v(_vm._s(_vm.T.wordsJustOutput)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm.showProblem
                          ? [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "col-6 col-sm pr-1 font-weight-bold",
                                },
                                [
                                  _vm._v(_vm._s(_vm.T.wordsProblem) + ": "),
                                  _c("omegaup-common-typeahead", {
                                    attrs: {
                                      "data-search-problem": "",
                                      "existing-options":
                                        _vm.searchResultProblems,
                                      value: _vm.filterProblem,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.filterProblem = $event
                                      },
                                      "update-existing-options": (query) =>
                                        _vm.$emit(
                                          "update-search-result-problems",
                                          query
                                        ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm.showUser
                          ? [
                              _c(
                                "label",
                                {
                                  staticClass: "col-5 col-sm font-weight-bold",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.T.contestParticipant) + ": "
                                  ),
                                  _c("omegaup-common-typeahead", {
                                    attrs: {
                                      "data-search-username": "",
                                      "existing-options": _vm.searchResultUsers,
                                      value: _vm.filterUsername,
                                      "max-results": 10,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.filterUsername = $event
                                      },
                                      "update-existing-options":
                                        _vm.updateSearchResultUsers,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "row" }, [
                      _vm.filtersExcludingOffset.length > 0
                        ? _c(
                            "div",
                            { staticClass: "col-sm col-12" },
                            [
                              _vm._l(
                                _vm.filtersExcludingOffset,
                                function (filter) {
                                  return _c(
                                    "span",
                                    {
                                      key: filter.name,
                                      staticClass: "btn-secondary mr-3",
                                    },
                                    [
                                      _c("span", { staticClass: "mr-2" }, [
                                        _vm._v(
                                          _vm._s(filter.name) +
                                            ": " +
                                            _vm._s(filter.value)
                                        ),
                                      ]),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            "data-remove-filter": filter.name,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onRemoveFilter(
                                                filter.name
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: ["fas", "times"] },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#runs",
                                    "data-remove-all-filters": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onRemoveFilter("all")
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "mr-2" }, [
                                    _vm._v(_vm._s(_vm.T.wordsRemoveFilter)),
                                  ]),
                                ]
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "table-responsive" },
            [
              _c("table", { staticClass: "table runs" }, [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "calendar-alt"] },
                        }),
                        _vm._v(" " + _vm._s(_vm.T.wordsTime) + " "),
                      ],
                      1
                    ),
                    _c(
                      "th",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGUID,
                            expression: "showGUID",
                          },
                        ],
                      },
                      [_vm._v(_vm._s(_vm.T.runGUID))]
                    ),
                    _c("th", [_vm._v(_vm._s(_vm.T.wordsLanguage))]),
                    _vm.showUser
                      ? _c("th", [_vm._v(_vm._s(_vm.T.contestParticipant))])
                      : _vm._e(),
                    _vm.showContest
                      ? _c("th", [_vm._v(_vm._s(_vm.T.wordsContest))])
                      : _vm._e(),
                    _vm.showProblem
                      ? _c("th", [_vm._v(_vm._s(_vm.T.wordsProblem))])
                      : _vm._e(),
                    _c("th", { attrs: { hidden: "" } }, [
                      _vm._v(_vm._s(_vm.T.wordsStatus)),
                    ]),
                    _vm.showPoints
                      ? _c("th", { staticClass: "numeric" }, [
                          _vm._v(_vm._s(_vm.T.wordsPoints)),
                        ])
                      : _vm._e(),
                    _vm.showPoints
                      ? _c("th", { staticClass: "numeric" }, [
                          _vm._v(_vm._s(_vm.T.wordsPenalty)),
                        ])
                      : _vm._e(),
                    !_vm.showPoints
                      ? _c("th", { staticClass: "numeric" }, [
                          _vm._v(" " + _vm._s(_vm.T.wordsPercentage) + " "),
                        ])
                      : _vm._e(),
                    _c("th", [_vm._v(_vm._s(_vm.T.wordsExecution))]),
                    _c("th", [_vm._v(_vm._s(_vm.T.wordsOutput))]),
                    _c(
                      "th",
                      { staticClass: "numeric" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "database"] },
                        }),
                        _vm._v(" " + _vm._s(_vm.T.wordsMemory) + " "),
                      ],
                      1
                    ),
                    _c(
                      "th",
                      { staticClass: "numeric" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "clock"] },
                        }),
                        _vm._v(" " + _vm._s(_vm.T.wordsRuntime) + " "),
                      ],
                      1
                    ),
                    _c("th", [
                      _vm._v(" " + _vm._s(_vm.T.arenaRunsActions) + " "),
                    ]),
                  ]),
                ]),
                _vm.problemAlias != null
                  ? _c("tfoot", [
                      _c("tr", [
                        _c(
                          "td",
                          { attrs: { colspan: "10", "data-new-run": "" } },
                          [
                            _vm.isContestFinished
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: `/arena/${_vm.contestAlias}/practice/`,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.T.arenaContestEndedUsePractice)
                                    ),
                                  ]
                                )
                              : _vm.useNewSubmissionButton
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "w-100",
                                    class: { disabled: !_vm.canSubmit },
                                    attrs: { disabled: !_vm.canSubmit },
                                    on: { click: _vm.onSubmit },
                                  },
                                  [
                                    !_vm.canSubmit
                                      ? _c("omegaup-countdown", {
                                          attrs: {
                                            "target-time":
                                              _vm.nextSubmissionTimestamp,
                                            "countdown-format":
                                              _vm.omegaup.CountdownFormat
                                                .WaitBetweenUploadsSeconds,
                                          },
                                          on: {
                                            finish: function ($event) {
                                              _vm.now = Date.now()
                                            },
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.newSubmissionDescription)
                                          ),
                                        ]),
                                  ],
                                  1
                                )
                              : _vm.canSubmit
                              ? _c(
                                  "a",
                                  {
                                    attrs: { href: _vm.newSubmissionUrl },
                                    on: { click: _vm.onSubmit },
                                  },
                                  [_vm._v(_vm._s(_vm.newSubmissionDescription))]
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("omegaup-countdown", {
                                      attrs: {
                                        "target-time":
                                          _vm.nextSubmissionTimestamp,
                                        "countdown-format":
                                          _vm.omegaup.CountdownFormat
                                            .WaitBetweenUploadsSeconds,
                                      },
                                      on: {
                                        finish: function ($event) {
                                          _vm.now = Date.now()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c(
                  "tbody",
                  _vm._l(_vm.paginatedRuns, function (run) {
                    return _c(
                      "tr",
                      {
                        key: run.guid,
                        class: { selected: _vm.createdGuid === run.guid },
                      },
                      [
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.time.formatDateLocalHHMM(run.time))
                          ),
                        ]),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showGUID,
                                expression: "showGUID",
                              },
                            ],
                          },
                          [
                            _c(
                              "acronym",
                              {
                                attrs: { title: run.guid, "data-run-guid": "" },
                              },
                              [
                                _c("tt", [
                                  _vm._v(_vm._s(_vm.getShortGuid(run.guid))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("td", [_vm._v(_vm._s(run.language))]),
                        _vm.showUser
                          ? _c(
                              "td",
                              {
                                staticClass: "text-break-all text-nowrap",
                                attrs: { "data-username": run.username },
                              },
                              [
                                _c("omegaup-user-username", {
                                  attrs: {
                                    classname: run.classname,
                                    username: run.username,
                                    country: run.country,
                                    linkify: true,
                                    href: "#runs",
                                    "emit-click-event": true,
                                  },
                                  on: {
                                    click: (username) =>
                                      (_vm.filterUsername = {
                                        key: username,
                                        value: username,
                                      }),
                                  },
                                }),
                                _c(
                                  "a",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      href: `/profile/${run.username}/`,
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: ["fas", "external-link-alt"],
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showContest
                          ? _c("td", { staticClass: "text-break-all" }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#runs" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEmitFilterChanged({
                                        filter: "contest",
                                        value: run.contest_alias,
                                      })
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(run.contest_alias))]
                              ),
                              run.contest_alias
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        href: `/arena/${run.contest_alias}/`,
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fas", "external-link-alt"],
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm.showProblem
                          ? _c("td", { staticClass: "text-break-all" }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#runs" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEmitFilterChanged({
                                        filter: "problem",
                                        value: run.alias,
                                      })
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(run.alias))]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    href: `/arena/problem/${run.alias}/`,
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: ["fas", "external-link-alt"],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "td",
                          {
                            staticClass:
                              "text-center opacity-4 font-weight-bold",
                            class: _vm.statusClass(run),
                            attrs: { "data-run-status": "", hidden: "" },
                          },
                          [
                            _c("span", { staticClass: "mr-1" }, [
                              _vm._v(_vm._s(_vm.status(run))),
                            ]),
                            !!_vm.statusHelp(run)
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline-dark btn-sm",
                                    attrs: {
                                      type: "button",
                                      "data-content": _vm.statusHelp(run),
                                      "data-toggle": "popover",
                                      "data-trigger": "focus",
                                    },
                                    on: { click: _vm.showVerdictHelp },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: {
                                        icon: ["fas", "question-circle"],
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm.showPoints
                          ? _c("td", { staticClass: "numeric" }, [
                              _vm._v(_vm._s(_vm.points(run))),
                            ])
                          : _vm._e(),
                        _vm.showPoints
                          ? _c("td", { staticClass: "numeric" }, [
                              _vm._v(_vm._s(_vm.penalty(run))),
                            ])
                          : _vm._e(),
                        !_vm.showPoints
                          ? _c(
                              "td",
                              {
                                staticClass: "numeric",
                                class: _vm.statusPercentageClass(run),
                                attrs: { "data-run-percentage": "" },
                              },
                              [_vm._v(" " + _vm._s(_vm.percentage(run)) + " ")]
                            )
                          : _vm._e(),
                        _c("td", { staticClass: "numeric" }, [
                          _vm._v(_vm._s(_vm.execution(run))),
                        ]),
                        _c(
                          "td",
                          { staticClass: "numeric" },
                          [
                            _vm._v(" " + _vm._s(_vm.output(run)) + " "),
                            _vm.outputIconColorStatus(run) !=
                            _vm.NumericOutputStatus.None
                              ? _c("br")
                              : _vm._e(),
                            _vm.outputIconColorStatus(run) ===
                            _vm.NumericOutputStatus.Correct
                              ? _c("font-awesome-icon", {
                                  staticStyle: { color: "green" },
                                  attrs: { icon: ["fas", "check-circle"] },
                                })
                              : _vm.outputIconColorStatus(run) ===
                                _vm.NumericOutputStatus.Incorrect
                              ? _c("font-awesome-icon", {
                                  staticStyle: { color: "red" },
                                  attrs: { icon: ["fas", "times-circle"] },
                                })
                              : _vm.outputIconColorStatus(run) ===
                                _vm.NumericOutputStatus.Interrupted
                              ? _c("font-awesome-icon", {
                                  staticStyle: { color: "orange" },
                                  attrs: {
                                    icon: ["fas", "exclamation-circle"],
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("td", { staticClass: "numeric" }, [
                          _vm._v(_vm._s(_vm.memory(run))),
                        ]),
                        _c("td", { staticClass: "numeric" }, [
                          _vm._v(_vm._s(_vm.runtime(run))),
                        ]),
                        _vm.showDetails &&
                        !_vm.showDisqualify &&
                        !_vm.showRejudge
                          ? _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "details btn-outline-dark btn-sm",
                                  attrs: { "data-run-details": run.guid },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onRunDetails(run)
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "search-plus"] },
                                  }),
                                  run.suggestions && run.suggestions > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute badge badge-danger",
                                        },
                                        [_vm._v(_vm._s(run.suggestions) + " ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm.requestFeedback
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "details btn-outline-dark btn-sm ml-1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "request-feedback",
                                            run.guid
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          title: _vm.T.courseRequestFeedback,
                                          icon: "comment-dots",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm.showDetails ||
                            _vm.showDisqualify ||
                            _vm.showRejudge
                          ? _c("td", { attrs: { "data-actions": run.guid } }, [
                              _c(
                                "div",
                                { staticClass: "d-inline-block mr-2" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "details btn-outline-dark btn-sm",
                                      attrs: {
                                        "data-runs-show-details-button": "",
                                        "data-run-details": run.guid,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onRunDetails(run)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "search-plus"] },
                                      }),
                                      run.suggestions && run.suggestions > 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute badge badge-danger",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(run.suggestions) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "dropdown d-inline-block" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-secondary dropdown-toggle",
                                      attrs: {
                                        "data-runs-actions-button": "",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.T.arenaRunsActions) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "dropdown-menu" },
                                    [
                                      _vm.showRejudge
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn-link dropdown-item",
                                              attrs: {
                                                "data-actions-rejudge":
                                                  run.guid,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit(
                                                    "rejudge",
                                                    run
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.T
                                                      .arenaRunsActionsRejudge
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showDisqualify
                                        ? [
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            run.type === "normal"
                                              ? [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-link dropdown-item",
                                                      attrs: {
                                                        "data-actions-disqualify":
                                                          run.guid,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "disqualify",
                                                            {
                                                              run,
                                                              disqualificationType:
                                                                _vm
                                                                  .DisqualificationType
                                                                  .ByGUID,
                                                            }
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.T
                                                              .arenaRunsActionsDisqualifyByGUID
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : run.type === "disqualified"
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-link dropdown-item",
                                                    attrs: {
                                                      "data-actions-requalify":
                                                        run.guid,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$emit(
                                                          "requalify",
                                                          run
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.T
                                                            .arenaRunsActionsRequalify
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ])
                          : _c("td"),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              !_vm.showFilters
                ? _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.itemsPerPage,
                      align: "center",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._t("runs", function () {
        return [
          _c("omegaup-overlay", {
            attrs: {
              "show-overlay":
                _vm.currentPopupDisplayed !== _vm.PopupDisplayed.None,
            },
            on: { "hide-overlay": _vm.onPopupDismissed },
            scopedSlots: _vm._u([
              {
                key: "popup",
                fn: function () {
                  return [
                    _c("omegaup-arena-rundetails-popup", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.currentPopupDisplayed ===
                            _vm.PopupDisplayed.RunDetails,
                          expression:
                            "currentPopupDisplayed === PopupDisplayed.RunDetails",
                        },
                      ],
                      attrs: { data: _vm.currentRunDetailsData },
                      on: { dismiss: _vm.onPopupDismissed },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }